import React from "react";
import { depascalize, Icon, Stack, Text, Theme } from "sprint-common-web";

import { OrderRequestStatus } from "../../../../common/types/OrderRequestStatus";
import { useOrderRequestDetails } from "../hooks/useOrderRequestDetails";

export const OrderRequestDetailsStatus = (): JSX.Element => {
    const { orderRequest } = useOrderRequestDetails();

    if (!orderRequest) {
        return <></>;
    }

    return (
        <Stack verticalAlign="center" horizontal={true} tokens={{ childrenGap: 8 }}>
            <Icon size={16} color={Theme.palette.themePrimary} iconName={statusIcons[orderRequest.status]} />
            <Text>Status: </Text>
            <Text testId="order-status">{depascalize(OrderRequestStatus[orderRequest.status])}</Text>
        </Stack>
    );
};

const statusIcons: Record<OrderRequestStatus, string> = {
    [OrderRequestStatus.Pending]: "Questionnaire",
    [OrderRequestStatus.CloudProcessing]: "Completed",
    [OrderRequestStatus.OnPremProcessing]: "Completed",
    [OrderRequestStatus.Invalid]: "Error",
    [OrderRequestStatus.Cancelled]: "Error"
};
